"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _recipient = require("./recipient.constant");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // @flow
var INIT_STATE = {
  // common
  uniqueMail: null,
  uniqueReferenceNo: null,
  list: null,
  listLink: null,
  listSearch: null,
  create: null,
  fundIdList: null,
  update: null,
  linkedFund: null,
  saveLinkedFund: null,
  lock: null,
  lockBulk: null,
  unlock: null,
  unlockBulk: null,
  softDelete: null,
  softDeleteBulk: null,
  submit: null,
  submitBulk: null,
  approve: null,
  approveBulk: null,
  copyUrl: null,
  download: null,
  downloadAll: null,
  downloadSurveyResponse: null,
  // deleted data
  softDeleteList: null,
  restore: null,
  restoreBulk: null,
  delete: null,
  deleteBulk: null,
  // uploader
  prefight: null,
  import: null,
  errorSheetDownload: null,
  getSurveyRecipientResponse: null,
  // link
  checkRecipient: null,
  checkSurvey: null,
  linkSurveyAndRecipientResponse: null,
  linkSingleSoftDelete: null,
  linkSingleSoftDeleteBulk: null,
  unpagedStatusList: null,
  // response
  configFetchResponse: null,
  // default
  loading: false
};
var recipient = function recipient() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    // common
    case _recipient.actionTypes.SAVE_LINKED_FUND_RESET:
      return _objectSpread(_objectSpread({}, state), {}, {
        saveLinkedFund: null
      });
    case _recipient.actionTypes.LINKED_FUND_RESET:
      return _objectSpread(_objectSpread({}, state), {}, {
        linkedFund: null
      });
    case _recipient.actionTypes.UNIQUE_REFERENCE_NO_RESET:
      return _objectSpread(_objectSpread({}, state), {}, {
        uniqueReferenceNo: null
      });
    case _recipient.actionTypes.UNIQUE_REFERENCE_NO:
      return _objectSpread(_objectSpread({}, state), {}, {
        // loading: true,
        uniqueReferenceNo: state.uniqueReferenceNo
      });
    case _recipient.actionTypes.UNIQUE_MAIL_RESET:
      return _objectSpread(_objectSpread({}, state), {}, {
        uniqueMail: null
      });
    case _recipient.actionTypes.LINK_SURVEY_AND_RECIPIENT_RESPONSE_RESET:
      return _objectSpread(_objectSpread({}, state), {}, {
        linkSurveyAndRecipientResponse: null
      });
    case _recipient.actionTypes.UNIQUE_MAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        // loading: true,
        uniqueMail: state.uniqueReferenceNo
      });
    case _recipient.actionTypes.LIST:
      return _objectSpread(_objectSpread({}, state), {}, {
        list: state.list
      });
    case _recipient.actionTypes.LIST_LINK:
      return _objectSpread(_objectSpread({}, state), {}, {
        listLink: state.listLink
      });
    case _recipient.actionTypes.LIST_SEARCH:
      return _objectSpread(_objectSpread({}, state), {}, {
        listSearch: state.listSearch
      });
    case _recipient.actionTypes.CREATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        create: state.create
      });
    case _recipient.actionTypes.SET_FUND_ID_LIST:
      return _objectSpread(_objectSpread({}, state), {}, {
        fundIdList: action.payload.data
      });
    case _recipient.actionTypes.UPDATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        update: state.update
      });
    case _recipient.actionTypes.LINKED_FUND:
      return _objectSpread(_objectSpread({}, state), {}, {
        linkedFund: state.linkedFund
      });
    case _recipient.actionTypes.SAVE_LINKED_FUND:
      return _objectSpread(_objectSpread({}, state), {}, {
        saveLinkedFund: state.saveLinkedFund
      });
    case _recipient.actionTypes.LOCK:
      return _objectSpread(_objectSpread({}, state), {}, {
        lock: state.lock
      });
    case _recipient.actionTypes.LOCK_BULK:
      return _objectSpread(_objectSpread({}, state), {}, {
        lockBulk: state.lockBulk
      });
    case _recipient.actionTypes.UNLOCK:
      return _objectSpread(_objectSpread({}, state), {}, {
        unlock: state.unlock
      });
    case _recipient.actionTypes.UNLOCK_BULK:
      return _objectSpread(_objectSpread({}, state), {}, {
        unlockBulk: state.unlockBulk
      });
    case _recipient.actionTypes.SOFT_DELETE:
      return _objectSpread(_objectSpread({}, state), {}, {
        softDelete: state.softDelete
      });
    case _recipient.actionTypes.SOFT_DELETE_BULK:
      return _objectSpread(_objectSpread({}, state), {}, {
        softDeleteBulk: state.softDeleteBulk
      });
    case _recipient.actionTypes.SUBMIT:
      return _objectSpread(_objectSpread({}, state), {}, {
        submit: state.submit
      });
    case _recipient.actionTypes.SUBMIT_BULK:
      return _objectSpread(_objectSpread({}, state), {}, {
        submitBulk: state.submitBulk
      });
    case _recipient.actionTypes.APPROVE:
      return _objectSpread(_objectSpread({}, state), {}, {
        approve: state.approve
      });
    case _recipient.actionTypes.APPROVE_BULK:
      return _objectSpread(_objectSpread({}, state), {}, {
        approveBulk: state.approveBulk
      });
    case _recipient.actionTypes.COPY_URL:
      return _objectSpread(_objectSpread({}, state), {}, {
        copyUrl: state.copyUrl
      });
    case _recipient.actionTypes.DOWNLOAD:
      return _objectSpread(_objectSpread({}, state), {}, {
        download: state.download
      });
    case _recipient.actionTypes.DOWNLOAD_ALL:
      return _objectSpread(_objectSpread({}, state), {}, {
        downloadAll: state.downloadAll
      });
    case _recipient.actionTypes.DOWNLOAD_SURVEY_RESPONSE:
      return _objectSpread(_objectSpread({}, state), {}, {
        downloadSurveyResponse: state.downloadSurveyResponse
      });
    // deleted data
    case _recipient.actionTypes.SOFT_DELETE_LIST:
      return _objectSpread(_objectSpread({}, state), {}, {
        softDeleteList: state.softDeleteList
      });
    case _recipient.actionTypes.RESTORE:
      return _objectSpread(_objectSpread({}, state), {}, {
        restore: state.restore
      });
    case _recipient.actionTypes.RESTORE_BULK:
      return _objectSpread(_objectSpread({}, state), {}, {
        restoreBulk: state.restoreBulk
      });
    case _recipient.actionTypes.DELETE:
      return _objectSpread(_objectSpread({}, state), {}, {
        delete: state.delete
      });
    case _recipient.actionTypes.DELETE_BULK:
      return _objectSpread(_objectSpread({}, state), {}, {
        deleteBulk: state.deleteBulk
      });
    // uploader
    case _recipient.actionTypes.PREFIGHT:
      return _objectSpread(_objectSpread({}, state), {}, {
        prefight: state.prefight
      });
    case _recipient.actionTypes.IMPORT:
      return _objectSpread(_objectSpread({}, state), {}, {
        import: state.import
      });
    case _recipient.actionTypes.ERROR_SHEET_DOWNLOAD:
      return _objectSpread(_objectSpread({}, state), {}, {
        errorSheetDownload: state.errorSheetDownload
      });
    case _recipient.actionTypes.GET_SURVEY_RECIPENT_RESPONSE:
      return _objectSpread(_objectSpread({}, state), {}, {
        getSurveyRecipientResponse: state.getSurveyRecipientResponse
      });
    // link
    case _recipient.actionTypes.CHECK_RECIPIENT:
      return _objectSpread(_objectSpread({}, state), {}, {
        checkRecipient: state.checkRecipient
      });
    case _recipient.actionTypes.CHECK_SURVEY:
      return _objectSpread(_objectSpread({}, state), {}, {
        checkSurvey: state.checkSurvey
      });
    case _recipient.actionTypes.LINK_SURVEY_AND_RECIPIENT_RESPONSE:
      return _objectSpread(_objectSpread({}, state), {}, {
        linkSurveyAndRecipientResponse: state.linkSurveyAndRecipientResponse
      });
    case _recipient.actionTypes.LINK_SINGLE_SOFT_DELETE:
      return _objectSpread(_objectSpread({}, state), {}, {
        linkSingleSoftDelete: state.linkSingleSoftDelete
      });
    case _recipient.actionTypes.LINK_SINGLE_SOFT_DELETE_BULK:
      return _objectSpread(_objectSpread({}, state), {}, {
        linkSingleSoftDeleteBulk: state.linkSingleSoftDeleteBulk
      });
    case _recipient.actionTypes.LIST_UNPAGED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          unpagedStatusList: state.unpagedStatusList
        });
      }
    // response
    case _recipient.actionTypes.SURVEY_CONFIGURATION_FETCH_RESPONSE:
      return _objectSpread(_objectSpread({}, state), {}, {
        configFetchResponse: action.payload.data
      });
    case _recipient.actionTypes.SURVEY_CONFIGURATION_FETCH_RESPONSE_RESET:
      return _objectSpread(_objectSpread({}, state), {}, {
        configFetchResponse: null
      });
    case _recipient.actionTypes.SUCCESS:
      switch (action.payload.actionType) {
        // common
        case _recipient.actionTypes.UNIQUE_REFERENCE_NO:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            uniqueReferenceNo: action.payload.data
          });
        case _recipient.actionTypes.UNIQUE_MAIL:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            uniqueMail: action.payload.data
          });
        case _recipient.actionTypes.LIST:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            list: action.payload.data
          });
        case _recipient.actionTypes.LIST_LINK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            listLink: action.payload.data
          });
        case _recipient.actionTypes.LIST_SEARCH:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            listSearch: action.payload.data
          });
        case _recipient.actionTypes.CREATE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            create: action.payload.data
          });
        case _recipient.actionTypes.UPDATE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            update: action.payload.data
          });
        case _recipient.actionTypes.LINKED_FUND:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            linkedFund: action.payload.data
          });
        case _recipient.actionTypes.SAVE_LINKED_FUND:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            saveLinkedFund: action.payload.data
          });
        case _recipient.actionTypes.LOCK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            lock: action.payload.data
          });
        case _recipient.actionTypes.LOCK_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            lockBulk: action.payload.data
          });
        case _recipient.actionTypes.UNLOCK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            unlock: action.payload.data
          });
        case _recipient.actionTypes.UNLOCK_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            unlockBulk: action.payload.data
          });
        case _recipient.actionTypes.SOFT_DELETE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            softDelete: action.payload.data
          });
        case _recipient.actionTypes.SOFT_DELETE_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            softDeleteBulk: action.payload.data
          });
        case _recipient.actionTypes.SUBMIT:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            submit: action.payload.data
          });
        case _recipient.actionTypes.SUBMIT_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            submitBulk: action.payload.data
          });
        case _recipient.actionTypes.APPROVE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            approve: action.payload.data
          });
        case _recipient.actionTypes.APPROVE_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            approveBulk: action.payload.data
          });
        case _recipient.actionTypes.COPY_URL:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            copyUrl: action.payload.data
          });
        case _recipient.actionTypes.DOWNLOAD:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            download: action.payload.data
          });
        case _recipient.actionTypes.DOWNLOAD_ALL:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            downloadAll: action.payload.data
          });
        case _recipient.actionTypes.DOWNLOAD_SURVEY_RESPONSE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            downloadSurveyResponse: action.payload.data
          });
        // deleted data
        case _recipient.actionTypes.SOFT_DELETE_LIST:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            softDeleteList: action.payload.data
          });
        case _recipient.actionTypes.RESTORE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            restore: action.payload.data
          });
        case _recipient.actionTypes.RESTORE_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            restoreBulk: action.payload.data
          });
        case _recipient.actionTypes.DELETE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            delete: action.payload.data
          });
        case _recipient.actionTypes.DELETE_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            deleteBulk: action.payload.data
          });
        // uploader
        case _recipient.actionTypes.PREFIGHT:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            prefight: action.payload.data
          });
        case _recipient.actionTypes.IMPORT:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            import: action.payload.data
          });
        case _recipient.actionTypes.ERROR_SHEET_DOWNLOAD:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            errorSheetDownload: action.payload.data
          });
        case _recipient.actionTypes.GET_SURVEY_RECIPENT_RESPONSE:
          return _objectSpread(_objectSpread({}, state), {}, {
            getSurveyRecipientResponse: action.payload.data
          });
        // link
        case _recipient.actionTypes.CHECK_RECIPIENT:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            checkRecipient: action.payload.data
          });
        case _recipient.actionTypes.CHECK_SURVEY:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            checkSurvey: action.payload.data
          });
        case _recipient.actionTypes.LINK_SURVEY_AND_RECIPIENT_RESPONSE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            linkSurveyAndRecipientResponse: action.payload.data
          });
        case _recipient.actionTypes.LINK_SINGLE_SOFT_DELETE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            linkSingleSoftDelete: action.payload.data
          });
        case _recipient.actionTypes.LINK_SINGLE_SOFT_DELETE_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            linkSingleSoftDeleteBulk: action.payload.data
          });
        case _recipient.actionTypes.LIST_UNPAGED:
          {
            return _objectSpread(_objectSpread({}, state), {}, {
              unpagedStatusList: action.payload.data
            });
          }
        // response
        case _recipient.actionTypes.SURVEY_CONFIGURATION_FETCH_RESPONSE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            configFetchResponse: action.payload.data
          });
        default:
          return _objectSpread({}, state);
      }
    case _recipient.actionTypes.ERROR:
      switch (action.payload.actionType) {
        // common
        case _recipient.actionTypes.UNIQUE_REFERENCE_NO:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            uniqueReferenceNo: action.payload.error
          });
        case _recipient.actionTypes.UNIQUE_MAIL:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            uniqueMail: action.payload.error
          });
        case _recipient.actionTypes.LIST:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            list: action.payload.error
          });
        case _recipient.actionTypes.LIST_LINK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            listLink: action.payload.error
          });
        case _recipient.actionTypes.LIST_SEARCH:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            listSearch: action.payload.error
          });
        case _recipient.actionTypes.CREATE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            create: action.payload.error
          });
        case _recipient.actionTypes.UPDATE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            update: action.payload.error
          });
        case _recipient.actionTypes.LINKED_FUND:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            linkedFund: action.payload.error
          });
        case _recipient.actionTypes.SAVE_LINKED_FUND:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            saveLinkedFund: action.payload.error
          });
        case _recipient.actionTypes.LOCK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            lock: action.payload.error
          });
        case _recipient.actionTypes.LOCK_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            lockBulk: action.payload.error
          });
        case _recipient.actionTypes.UNLOCK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            unlock: action.payload.error
          });
        case _recipient.actionTypes.UNLOCK_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            unlockBulk: action.payload.error
          });
        case _recipient.actionTypes.SOFT_DELETE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            softDelete: action.payload.error
          });
        case _recipient.actionTypes.SOFT_DELETE_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            softDeleteBulk: action.payload.error
          });
        case _recipient.actionTypes.SUBMIT:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            submit: action.payload.error
          });
        case _recipient.actionTypes.SUBMIT_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            submitBulk: action.payload.error
          });
        case _recipient.actionTypes.APPROVE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            approve: action.payload.error
          });
        case _recipient.actionTypes.APPROVE_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            approveBulk: action.payload.error
          });
        case _recipient.actionTypes.COPY_URL:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            copyUrl: action.payload.error
          });
        case _recipient.actionTypes.DOWNLOAD:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            download: action.payload.error
          });
        case _recipient.actionTypes.DOWNLOAD_ALL:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            downloadAll: action.payload.error
          });
        case _recipient.actionTypes.DOWNLOAD_SURVEY_RESPONSE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            downloadSurveyResponse: action.payload.error
          });
        // deleted data
        case _recipient.actionTypes.SOFT_DELETE_LIST:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            softDeleteList: action.payload.error
          });
        case _recipient.actionTypes.RESTORE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            restore: action.payload.error
          });
        case _recipient.actionTypes.RESTORE_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            restoreBulk: action.payload.error
          });
        case _recipient.actionTypes.DELETE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            delete: action.payload.error
          });
        case _recipient.actionTypes.DELETE_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            deleteBulk: action.payload.error
          });
        // uploader
        case _recipient.actionTypes.PREFIGHT:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            prefight: action.payload.error
          });
        case _recipient.actionTypes.IMPORT:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            import: action.payload.error
          });
        case _recipient.actionTypes.ERROR_SHEET_DOWNLOAD:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            errorSheetDownload: action.payload.error
          });
        // analytics
        case _recipient.actionTypes.ANALYTICS_SAVE:
          return _objectSpread(_objectSpread({}, state), {}, {
            analyticsSave: action.payload.error
          });
        case _recipient.actionTypes.ANALYTICS_GET:
          return _objectSpread(_objectSpread({}, state), {}, {
            analyticsGet: action.payload.error
          });
        case _recipient.actionTypes.ANALYTICS_UPDATE:
          return _objectSpread(_objectSpread({}, state), {}, {
            analyticsUpdate: action.payload.error
          });
        case _recipient.actionTypes.ANALYTICS_RECENT_ACTIVITY:
          return _objectSpread(_objectSpread({}, state), {}, {
            analyticsRecentActivity: action.payload.error
          });
        case _recipient.actionTypes.ANALYTICS_FIND:
          return _objectSpread(_objectSpread({}, state), {}, {
            analyticsFind: action.payload.error
          });
        case _recipient.actionTypes.ANALYTICS_ACTIVITY_LOG_HISTORY:
          return _objectSpread(_objectSpread({}, state), {}, {
            analyticsActivityLogHistory: action.payload.error
          });
        case _recipient.actionTypes.ANALYTICS_LATEST_SESSION_RECORDING:
          return _objectSpread(_objectSpread({}, state), {}, {
            analyticsLatestSessionRecording: action.payload.error
          });
        case _recipient.actionTypes.ANALYTICS_SCORE:
          return _objectSpread(_objectSpread({}, state), {}, {
            analyticsScore: action.payload.error
          });
        case _recipient.actionTypes.GET_SURVEY_RECIPENT_RESPONSE:
          return _objectSpread(_objectSpread({}, state), {}, {
            getSurveyRecipientResponse: action.payload.error
          });
        // link
        case _recipient.actionTypes.CHECK_RECIPIENT:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            checkRecipient: action.payload.error
          });
        case _recipient.actionTypes.CHECK_SURVEY:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            checkSurvey: action.payload.error
          });
        case _recipient.actionTypes.LINK_SURVEY_AND_RECIPIENT_RESPONSE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            linkSurveyAndRecipientResponse: action.payload.error
          });
        case _recipient.actionTypes.LINK_SINGLE_SOFT_DELETE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            linkSingleSoftDelete: action.payload.error
          });
        case _recipient.actionTypes.LINK_SINGLE_SOFT_DELETE_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            linkSingleSoftDeleteBulk: action.payload.error
          });
        case _recipient.actionTypes.LIST_UNPAGED:
          {
            return _objectSpread(_objectSpread({}, state), {}, {
              unpagedStatusList: action.payload.error
            });
          }
        // response
        case _recipient.actionTypes.SURVEY_CONFIGURATION_FETCH_RESPONSE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            configFetchResponse: action.payload.error
          });
        default:
          return _objectSpread({}, state);
      }
    case _recipient.actionTypes.RESET:
      return _objectSpread({}, INIT_STATE);
    default:
      return _objectSpread({}, state);
  }
};
var _default = recipient;
exports.default = _default;